let cookieBar = document.querySelector(".cookie-bar");
let cookieBarClose = document.querySelector(".cookie-bar__close");
let cookieBarAccept = document.querySelector(".cookie-bar__accept");

const getCookie = (name) => {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

const setCookie = (name, value, days) => {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
};

const eraseCookie = (name) => {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
};

const checkIfAccepted = () => {
  if (!getCookie("cookies-accepted")) {
    cookieBar.classList.remove("cookie-bar--hidden");
  }
};

const handleClosebutton = () => {
  cookieBarClose.addEventListener("click", function (e) {
    e.preventDefault();
    cookieBar.classList.add("cookie-bar--hidden");
    setCookie("cookies-closed", "true", 365);
  });
};

const handleAcceptbutton = () => {
  cookieBarAccept.addEventListener("click", function (e) {
    e.preventDefault();
    cookieBar.classList.add("cookie-bar--hidden");
    setCookie("cookies-accepted", "true", 365);
    setCookie("necessary", "true", 365);
    setCookie("google-analytics", "true", 365);
    if (window.location.href.includes("cookies")) {
      window.location.reload();
    }
  });
};

var loadGA = function (url, implementationCode, location) {
  var scriptTag = document.createElement("script");
  scriptTag.src = url;

  scriptTag.onload = implementationCode;
  scriptTag.onreadystatechange = implementationCode;

  location.appendChild(scriptTag);
};

const sendGaLayer = () => {
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag("js", new Date());

  gtag("config", "UA-187337811-1");
};

function dispatchCookieChange() {
  if (getCookie("google-analytics")) {
    loadGA(
      "https://www.googletagmanager.com/gtag/js?id=UA-187337811-1",
      sendGaLayer,
      document.head
    );
  }

  if (getCookie("necessary")) {
    setCookie("cookies-accepted", "true", 365);
    setCookie("cookies-closed", "true", 365);
  } else {
    eraseCookie("cookies-closed");
    eraseCookie("cookies-accepted");
  }
}

function checkIfCookieExist() {
  let cookies = document.querySelectorAll(".js-handle-cookie");
  for (let i = 0; i < cookies.length; i++) {
    const element = cookies[i];
    let cookie = element.value;
    if (getCookie(cookie)) {
      element.checked = true;
    }
  }
}

function clickCookie() {
  let cookies = document.querySelectorAll(".js-handle-cookie");
  for (let i = 0; i < cookies.length; i++) {
    const element = cookies[i];
    element.addEventListener("click", function () {
      let cookie = element.value;
      if (element.checked) {
        setCookie(cookie, "true", 365);
        console.log("store", cookie);
      } else {
        console.log("erase", cookie);
        eraseCookie(cookie);
      }
    });

    dispatchCookieChange();
  }
}

export default function () {
  clickCookie();
  checkIfCookieExist();
  checkIfAccepted();
  handleClosebutton();
  handleAcceptbutton();
}
